import { styled } from "@mui/material/styles";

export const PhoneNumberContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: theme.space._1300,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._500,
    alignSelf: "stretch",

    "@media (max-width: 600px)": {
        width: "100%"
    }
}));
